import { BaseTeachingElement } from "./BaseTeachingElement";

/**
 * Данные одного ключевого слова.
 */
export interface KeysElementModel {

    /**
     * Правильный ответ.
     */
    answer: string;

    /**
     * Показывается ли ответ.
     */
    revealed: boolean;

}

/**
 * TeachingElement задания Keys.
 *
 * Отвечает только за отображение одного ключевого слова.
 */
export class KeysElement extends BaseTeachingElement {

    private model: KeysElementModel;

    constructor(
        model: KeysElementModel
    ) {

        super();

        this.model = model;

    }

    public setModel(
        model: KeysElementModel
    ): void {

       this.setModel(model);

    }

    public override mount(): void {

        this.root =
            document.createElement("span");

        this.root.className =
            "keys-wrap";

        const answer =
            document.createElement("span");

        answer.className =
            "gap-answer";

        if (this.model.revealed) {

            answer.textContent =
                this.model.answer;

        } else {

            answer.innerHTML =
                "&nbsp;";

        }

        this.root.appendChild(
            answer
        );

    }

    public override update(): void {

        const answer =
            this.root.querySelector<HTMLElement>(
                ".gap-answer"
            );

        if (!answer) {
            return;
        }

        if (this.model.revealed) {

            answer.textContent =
                this.model.answer;

        } else {

            answer.innerHTML =
                "&nbsp;";

        }

    }

    public override unmount(): void {
    }

}